export default {
    common: {
        confirm: '确定',
        cancel: '取消',
        save: '保存',
        success: '成功',
        fail: '失败',
        hint: '提示',
        send: '发送'
    },
    components: {
        setting: {
            UserConfig: {
                privacySettings: '隐私设置',
                friendVerify: '加我为好友时需要验证',
                notificationSettings: '通知设置',
                messageTone: '新消息提示音'
            },
            BindEmail: {
                successTitle: '邮箱绑定成功',
                successDesc: '您的邮箱 {email} 已成功绑定',
                suggestTitle: '建议绑定邮箱',
                suggestDesc: '绑定邮箱后，您可以通过邮箱快速重置密码，提高账户安全性',
                bindTitle: '邮箱绑定',
                emailLabel: '邮箱',
                emailPlaceholder: '请输入邮箱地址',
                codeLabel: '验证码',
                codePlaceholder: '请输入验证码',
                retryInSeconds: '{time}秒后重新获取',
                getCode: '获取验证码',
                bindBtn: '绑定',
                emailRequired: '请输入邮箱',
                emailFormatError: '邮箱格式错误',
                codeRequired: '请输入验证码',
                bindConfirm: '邮箱绑定后无法更改，是否绑定？',
                bindSuccess: '邮箱绑定成功',
                codeSent: '验证码已发送至您的邮箱，请注意查收',
                sendFail: '发送验证码失败'
            },
            BindPhone: {
                successTitle: '手机号绑定成功',
                successDesc: '您的手机号 {phone} 已成功绑定',
                suggestTitle: '建议绑定手机号',
                suggestDesc: '绑定手机号后，您可以通过手机号快速重置密码，提高账户安全性',
                bindTitle: '手机号绑定',
                phoneLabel: '手机号',
                phonePlaceholder: '请输入手机号码',
                codeLabel: '验证码',
                codePlaceholder: '请输入验证码',
                retryInSeconds: '{time}秒后重新获取',
                getCode: '获取验证码',
                bindBtn: '绑定',
                phoneRequired: '请输入手机号码',
                phoneFormatError: '手机号格式错误',
                codeRequired: '请输入验证码',
                bindConfirm: '手机号码绑定后无法更改，是否绑定？',
                bindSuccess: '手机号码绑定成功',
                codeSent: '验证码已发送至您的手机，请注意查收',
                sendFail: '发送验证码失败'
            },
            ModifyPassword: {
                title: '修改密码',
                oldPassword: '原密码',
                newPassword: '新密码',
                confirmPassword: '确认密码',
                submit: '提 交',
                passwordRequired: '请输入密码',
                passwordMismatch: '两次密码输入不一致',
                success: '修改成功'
            },
            PersonalInfo: {
                changeAvatar: '更换头像',
                defaultNickName: '未设置昵称',
                unknownUser: '未知用户',
                basicInfo: '基本信息',
                company: '企业',
                nickName: '昵称',
                nickNamePlaceholder: '请输入昵称',
                gender: '性别',
                male: '男',
                female: '女',
                contactInfo: '联系方式',
                phone: '手机号',
                noPhoneBound: '未绑定手机号',
                goToBind: '去绑定',
                email: '邮箱',
                noEmailBound: '未绑定邮箱',
                signature: '个性签名',
                signaturePlaceholder: '分享你的心情和想法...',
                submit: '提 交',
                nickNameRequired: '请输入昵称',
                success: '修改成功'
            },
            RealnameAuth: {
                successTitle: '实名认证成功',
                successDesc: '您的实名认证已通过审核',
                realName: '真实姓名',
                idCardNumber: '证件号码',
                authTime: '认证时间',
                pendingTitle: '实名认证审核中',
                pendingDesc: '您的实名认证申请正在审核中，请耐心等待',
                resubmit: '重新提交',
                failTitle: '实名认证失败',
                failReason: '失败原因',
                failDesc: '您的实名认证申请未通过审核，请重新提交',
                tipTitle: '实名认证说明',
                tipDesc: '实名认证可以提高账户安全性，请确保上传的身份证照片清晰可见，信息真实有效',
                resubmitTip: '重新提交将覆盖之前的认证信息',
                authTitle: '实名认证',
                realNamePlaceholder: '请输入真实姓名',
                idCardPlaceholder: '请输入身份证号码',
                idCardFront: '身份证正面',
                uploadFront: '上传身份证正面',
                frontTip: '请上传清晰的身份证正面照片',
                idCardBack: '身份证反面',
                uploadBack: '上传身份证反面',
                backTip: '请上传清晰的身份证反面照片',
                submitAuth: '提交认证',
                realNameRequired: '请输入真实姓名',
                realNameLength: '姓名长度应在2-20个字符之间',
                idCardRequired: '请输入身份证号码',
                idCardFormatError: '身份证号码格式错误',
                frontRequired: '请上传身份证正面照片',
                backRequired: '请上传身份证反面照片',
                confirmSubmit: '审核通过后信息将无法修改，是否确认提交？',
                 submitSuccess: '实名认证申请已提交，请等待审核',
                 preview: '预览'
            }
        },
        Login: {
            loadingText: '正在登陆...',
            title: '登录IM',
            passwordPlaceholder: '密码',
            autoLogin: '下次自动登录',
            forgotPassword: '忘记密码?',
            loginBtn: '登录',
            qrLogin: '扫码登录',
            registerLink: '没有账号? 立即注册',
            usernameRequired: '请输入用户名',
            passwordRequired: '请输入密码',
            loginSuccess: '登录成功',
            username: '用户名',
            phone: '手机号',
            email: '邮箱'
        },
        Register: {
            modeUsername: '用户名注册',
            modePhone: '手机注册',
            modeEmail: '邮箱注册',
            phonePlaceholder: '手机号码',
            codePlaceholder: '短信验证码',
            emailPlaceholder: '邮箱',
            emailCodePlaceholder: '邮件验证码',
            usernamePlaceholder: '用户名',
            passwordPlaceholder: '密码',
            confirmPasswordPlaceholder: '确认密码',
            getCode: '获取验证码',
            retryInSeconds: '{time}秒后重新获取',
            registerBtn: '注册',
            toLogin: '已有账号? 去登录',
            otherMode: '其他注册方式',
            phoneRequired: '请输入手机号码',
            phoneFormatError: '手机号格式错误',
            emailRequired: '请输入邮箱',
            emailFormatError: '邮箱格式错误',
            usernameRequired: '请输入用户名',
            passwordRequired: '请输入密码',
            passwordMismatch: '两次密码输入不一致',
            registerSuccess: '注册成功，欢迎使用{appName}！',
            codeSentPhone: '验证码已发送至您的手机，请注意查收',
            codeSentEmail: '验证码已发送至您的邮箱，请注意查收'
        },
        ResetPwd: {
            title: '密码重置向导',
            subTitle: '只需四步，轻松重置您的密码',
            step1: '选择方式',
            step2: '验证身份',
            step3: '设置密码',
            step4: '完成',
            selectMode: '请选择密码重置方式',
            phoneMode: '手机号重置',
            phoneModeDesc: '通过短信验证码验证身份',
            emailMode: '邮箱重置',
            emailModeDesc: '通过邮箱验证码验证身份',
            nextStep: '下一步',
            verifyIdentity: '验证您的身份',
            phoneLabel: '手机号码',
            phoneInputPlaceholder: '请输入您的手机号码',
            smsCodeLabel: '短信验证码',
            smsCodeInputPlaceholder: '请输入短信验证码',
            resend: '秒后重发',
            emailLabel: '邮箱地址',
            emailInputPlaceholder: '请输入您的邮箱地址',
            emailCodeLabel: '邮箱验证码',
            emailCodeInputPlaceholder: '请输入6位邮箱验证码',
            prevStep: '上一步',
            verifyBtn: '验证',
            setNewPwd: '设置新密码',
            newPwdLabel: '新密码',
            newPwdPlaceholder: '请输入您的新密码',
            confirmPwdLabel: '确认新密码',
            confirmPwdPlaceholder: '请再次输入您的新密码',
            submitBtn: '提交',
            successTitle: '密码重置成功！',
            successDesc: '您已成功重置密码，请使用新密码登录您的账户。',
            autoRedirect: '系统将在 {time} 秒后自动跳转到登录页面',
            loginNow: '立即登录',
            phoneError: '请输入正确的手机号',
            emailError: '请输入正确的邮箱地址',
            verifyFail: '验证失败,请重新输入验证码',
            cancelConfirm: '确定要取消密码重置吗？'
        },
        RtcGroupVideo: {
            title: '视频通话',
            microphoneOn: '关闭麦克风',
            microphoneOff: '打开麦克风',
            speakerOn: '关闭扬声器',
            speakerOff: '打开扬声器',
            cameraOn: '关闭摄像头',
            cameraOff: '打开摄像头',
            shareScreen: '共享屏幕',
            cancelShare: '停止共享',
            inviteMember: '邀请成员',
            quitCall: '结束通话',
            status: {
                chatting: '通话中',
                calling: '呼叫中'
            },
            success: {
                join: '成功加入通话',
                leave: '已离开通话',
                invite: '邀请成功'
            },
            error: {
                cameraAccessFailed: '无法访问摄像头',
                rtcInitFailed: 'RTC初始化失败',
                deviceNotSupport: '您的设备不支持通话',
                joinFailed: '加入通话失败',
                leaveFailed: '离开通话失败'
            }
        },
        AddFriend: {
            title: '添加好友',
            placeholder: 'ID/昵称/手机号/邮箱,最多展示20条',
            tag: {
                deleted: '已注销',
                banned: '已封禁'
            },
            label: {
                phone: '手机',
                email: '邮箱',
                id: 'ID'
            },
            button: {
                sendMessage: '发消息',
                add: '加为好友'
            },
            status: {
                waiting: '等待对方验证'
            },
            noData: "未搜索到'{searchText}'相关的用户"
        },
        FriendApply: {
            title: '申请添加好友',
            tip: '提示: 对方开启了好友验证,等待对方同意后才能成为好友',
            remark: '我是{name}',
            success: {
                approved: "添加成功，'{name}'已成为您的好友",
                pending: "您向'{name}'发起了好友申请"
            }
        },
        FriendItem: {
            online: {
                computer: '电脑设备在线',
                mobile: '移动设备在线'
            },
            menu: {
                chat: '发送消息',
                card: '分享名片',
                delete: '删除好友'
            }
        },
        FriendRequest: {
            tab: {
                received: '收到的申请({count})',
                sent: '发起的申请({count})'
            }
        },
        FriendRequestItem: {
            text: {
                sender: '请求添加对方为好友',
                receiver: '请求添加您为好友'
            },
            button: {
                reject: '拒绝',
                approve: '同意',
                recall: '撤回'
            },
            success: {
                approve: '{name} 已成为您的好友',
                reject: '您拒绝了 {name} 的好友请求',
                recall: '您撤回了 {name} 的好友请求'
            }
        },
        ChatSelector: {
            search: {
                placeholder: '搜索'
            },
            tags: {
                group: '群'
            },
            tips: {
                checkedCount: '已勾选{count}个联系人'
            },
            buttons: {
                remove: '移除'
            },
            tabs: {
                recent: '最近聊天',
                friends: '好友',
                groups: '群聊'
            }
        },

        Complaint: {
            title: '投诉',
            form: {
                target: '投诉对象',
                type: '投诉原因',
                images: '图片证据',
                content: '投诉内容'
            },
            placeholder: '请输入投诉内容',
            required: {
                type: '请选择投诉原因',
                content: '请输入投诉内容'
            },
            success: '我们已收到您的投诉，工作人员会在3个工作日内核实并处理',
            image: {
                count: '您上传了{count}张图片',
                max: '最多上传{max}张图片'
            }
        },
        ChatHistory: {
            title: '聊天记录',
            search: {
                placeholder: '搜索聊天记录'
            },
            tabs: {
                all: '全部',
                text: '文字',
                image: '图片',
                sticker: '表情',
                file: '文件',
                voice: '语音',
                video: '视频'
            },
            menu: {
                locate: '在聊天中定位'
            },
            uploadedAt: '上传于',
            noData: '没有数据',
            noResult: "未搜索到与'{text}'相关的内容"
        },
        ChatRecord: {
            title: '语音录制',
            duration: '时长',
            states: {
                stop: '未开始',
                running: '正在录音...',
                pause: '已暂停录音',
                complete: '已结束录音'
            },
            buttons: {
                start: '开始录音',
                pause: '暂停录音',
                resume: '继续录音',
                complete: '结束录音',
                play: '播放录音',
                stop: '停止播放',
                restart: '重新录音',
                send: '立即发送'
            }
        },
        RtcGroupAcceptor: {
            unknownUser: '未知用户',
            callStatus: '邀请您进行视频通话',
            participantsTitle: '其他参与者',
            accept: '接听',
            reject: '拒绝'
        },
        RtcGroupJoin: {
            title: '视频通话邀请',
            host: '主持人：',
            usersCount: '当前共 {count} 人在通话中'
        },
        GroupMemberSelector: {
            title: '选择成员',
            placeholder: '搜索成员',
            tip: '已选择 {count} 人',
            error: {
                maxMembers: '最多只能选择 {max} 人'
            }
        },
        GroupItem: {
            menu: {
                chat: '发送消息',
                card: '分享名片',
                dissolve: '解散群聊',
                quit: '退出群聊'
            }
        },
        GroupInfo: {
            tag: {
                banned: '封禁'
            },
            label: {
                owner: '群主',
                members: '群成员',
                person: '人'
            },
            button: {
                sendMessage: '发消息',
                join: '加入群聊'
            }
        },
        AddGroupMember: {
            title: '邀请群成员',
            placeholder: '搜索好友',
            tip: '已勾选{count}位好友',
            success: '邀请成功'
        },
        GroupMemberBar: {
            tag: {
                me: '我',
                owner: '群主',
                manager: '管理员',
                muted: '已禁言'
            }
        },
        GroupMemberDialog: {
            title: '群成员',
            tooltip: {
                invite: '邀请成员',
                remove: '移除成员',
                mute: '禁言成员',
                unmute: '解除禁言'
            },
            button: {
                invite: '邀请',
                remove: '移除',
                mute: '禁言',
                unmute: '解除'
            }
        },
        GroupMemberItem: {
            menu: {
                sendMessage: '发送消息',
                userInfo: '查看资料',
                addFriend: '添加好友',
                mute: '禁言',
                unmute: '解除禁言',
                kick: '移出群聊',
                addManager: '设为管理员',
                removeManager: '取消管理员'
            },
            success: {
                mute: '已禁言{name}',
                unmute: '已解除{name}的禁言',
                kick: '已将{name}移出群聊',
                addManager: '已将{name}设为管理员',
                removeManager: '已取消{name}的管理员身份'
            },
            confirm: {
                title: '确认操作',
                kick: '确定要将{name}移出群聊吗？'
            }
        },
        UserProfileCard: {
            title: '个人资料',
            status: {
                online: '在线'
            },
            detail: {
                company: '企业',
                gender: '性别',
                phone: '手机号',
                email: '邮箱',
                signature: '个性签名'
            },
            gender: {
                male: '男',
                female: '女',
                unknown: '保密'
            },
            signature: {
                empty: {
                    title: '未设置个性签名',
                    desc: '设置个性签名，展示独特的自己'
                }
            }
        },
        Chat: {
            searchPlaceholder: '搜索',
            loadingText: '消息接收中...',
            deleteConfirm: '删除后记录将清空,确认删除与"{name}"的聊天 ?',
            deleteChat: '删除会话',
            notInGroup: '您已不在群聊中，无法查看群资料'
        },
        Friend: {
            searchPlaceholder: '搜索',
            addFriend: '添加好友',
            newFriend: '新的朋友',
            sendMessage: '发消息',
            addAsFriend: '加为好友',
            deleteFriend: '删除好友',
            deleteFriendConfirm: '确认删除"{name}",并清空聊天记录吗?',
            deleteFriendConfirmTitle: '确认解除?',
            deleteFriendSuccess: '删除好友成功',
            sendSuccess: '发送成功',
            editRemark: '修改备注',
            inputRemark: '请输入好友备注',
            remarkLengthError: '好友备注长度不能大于32',
            shareCard: '分享名片',
            complaint: '投诉',
            online: '在线',
            userInfo: {
                username: '用户名(ID)',
                nickName: '昵称',
                company: '所在企业',
                remark: '备注名',
                gender: '性别',
                signature: '个性签名',
                noRemark: '未设置备注名',
                noSignature: '这个人很懒，什么都没有留下',
                male: '男',
                female: '女'
            }
        },
        Service: {
            title: '服务',
            noService: '暂无服务',
            sendMessage: '发消息',
            selectTip: '请选择服务号',
            company: '所在企业',
            detail: '服务描述'
        },
        Group: {
            searchPlaceholder: '搜索',
            createGroup: '创建群聊',
            changeAvatar: '更换头像',
            viewAllMembers: '查看全部成员',
            sendMessage: '发消息',
            save: '保存',
            quitGroup: '退出',
            dissolveGroup: '解散',
            shareCard: '分享名片',
            complaint: '投诉',
            groupInfo: {
                owner: '群主',
                groupName: '群名',
                remarkName: '备注名',
                myNickname: '我在本群的昵称',
                notice: '群公告',
                noNotice: '群主未设置',
                groupMessageLanguage: '群消息语言',
                adminLanguage: '管理员语言',
                selectLanguage: '请选择语言'
            },
            createDialog: {
                title: '创建群聊',
                inputPlaceholder: '请输入群聊名称',
                inputError: '请输入群聊名称',
                lengthError: '群聊名称长度不能大于20'
            },
            success: {
                create: '创建成功',
                send: '发送成功',
                save: '修改成功',
                removeMember: '您移除了{count}位成员',
                muteMember: '您对{count}位成员进行了禁言',
                unmuteMember: '您解除了{count}位成员的禁言',
                dissolve: '群聊"{name}"已解散',
                quit: '您已退出"{name}"'
            },
            confirm: {
                dissolve: '确认要解散"{name}"吗?',
                dissolveTitle: '确认解散?',
                quit: '确认退出"{name}",并清空聊天记录吗？',
                quitTitle: '确认退出?'
            },
            menu: {
                chat: '发送消息',
                shareCard: '分享名片',
                complaint: '投诉',
                dissolve: '解散群聊',
                quit: '退出群聊'
            }
        },
        Setting: {
            menu: {
                personalInfo: '个人资料',
                userConfig: '用户设置',
                bindPhone: '绑定手机',
                bindEmail: '绑定邮箱',
                modifyPassword: '修改密码',
                realnameAuth: '实名认证'
            }
        },
        Home: {
            exit: '退出',
            alert: {
                forceOffline: {
                    message: '您已在其他地方登录，将被强制下线',
                    title: '强制下线通知'
                },
                banned: {
                    message: '您的账号已被管理员封禁,原因:{reason}',
                    title: '账号被封禁'
                },
                unreg: {
                    message: '您的账号已注销'
                },
                confirm: '确定'
            },
            message: {
                initFail: '初始化失败',
                online: '在线',
                reconnecting: '连接断开，正在尝试重新连接...',
                reconnectSuccess: '重新连接成功',
                offlineMessageFail: '拉取离线消息失败'
            },
            systemNotice: '系统通知',
            unknownUser: '未知用户',
            unknownGroup: '未知群聊'
        },
        ChatBox: {
            groupInfo: '群聊信息',
            translatePlaceholder: '请输入要翻译的内容...',
            translate: {
                emptyTip: '请输入要翻译的内容'
            },
            forward: '转发消息',
            atTip: '有⼈@我',
            newMessageTip: '有 {count} 条新消息',
            scrollToBottom: '回到底部',
            sendBtn: '发送(S)',
            tool: {
                emotion: '表情',
                translate: '翻译',
                screenshot: '截图(CTRL + ALT + A)',
                image: '发送图片',
                video: '发送视频',
                file: '发送文件',
                receipt: '回执消息',
                voice: '发送语音',
                voiceCall: '语音通话',
                groupCall: '多人通话',
                videoCall: '视频通话',
                history: '聊天记录'
            },
            screenshot: {
                hideWindow: '隐藏当前窗口截图'
            },
            call: {
                notFriend: '非好友不能通话',
                inCall: '当前正在通话中'
            },
            copy: {
                success: '内容已复制到剪贴板',
                fail: '复制失败，请手动复制'
            },
            resend: {
                notSupported: '该消息不支持自动重新发送，建议手动重新发送'
            },
            delete: {
                confirm: '确认删除消息?',
                title: '删除消息',
                confirmBtn: '确定',
                cancelBtn: '取消'
            },
            sticker: {
                addSuccess: '已添加到自定义表情'
            },
            batchDelete: {
                selectFirst: '请先选择要删除的消息',
                confirm: '确认删除选中的 {count} 条消息?',
                title: '批量删除消息',
                confirmBtn: '确定',
                cancelBtn: '取消',
                success: '删除成功'
            },
            batchForward: {
                selectFirst: '请先选择要转发的消息',
                filterTip: '你选择的消息中, 名片消息、通话消息以及未发送成功的消息将不能转发,是否继续?',
                tipTitle: '提示',
                confirmBtn: '继续发送',
                cancelBtn: '取消',
                noMessages: '没有可转发的消息',
                success: '成功转发 {count} 条消息到 {chats} 个会话',
                partialSuccess: '成功转发 {success}/{total} 条消息，部分消息转发失败'
            },
            mergeForward: {
                minCount: '合并转发至少需要选择2条消息',
                unsentTip: '你选择的消息中，有 {count} 条未发送成功的消息不能转发，是否继续转发其他消息？',
                tipTitle: '提示',
                confirmBtn: '继续转发',
                cancelBtn: '取消',
                noMessages: '没有可转发的消息',
                title: '聊天记录',
                groupTitle: "群聊'{groupName}'的聊天记录",
                privateTitle: "'{name1}'和'{name2}'的聊天记录"
            },
            multiSelect: {
                selected: '已选择 {count} 条',
                maxLimit: '最多只能选择 20 条消息',
                forwardOneByOne: '逐条转发',
                mergeForward: '合并转发',
                delete: '批量删除',
                cancel: '取消多选'
            }
        },
            ChatTopMessage: {
                title: '置顶消息',
                remove: '移除',
                confirmRemove: '将在当前群聊的所有成员中移除此置顶消息,确认移除？',
                removeTitle: '移除置顶',
                removeBtn: '移除',
                cancelBtn: '取消'
            },
            ChatQuoteMessage: {
                userCard: '个人名片',
                groupCard: '群名片',
                mergeForward: '合并转发',
                mergeForwardCount: '共{count}条消息',
                unsupportedType: '[暂不支持该消息类型]'
            },
        ChatMessageItem: {
            groupOwner: '群主',
            groupManager: '管理员',
            messageCount: '{count}条消息',
            unsupportedType: '[暂不支持该消息类型]',
            readed: '已读',
            unread: '未读',
            allRead: '全体已读',
            readCount: '{count}人已读',
            menu: {
                copy: '复制',
                addSticker: '添加到表情',
                multiSelect: '多选',
                delete: '删除',
                recall: '撤回',
                quote: '引用',
                forward: '转发',
                top: '置顶',
                locateQuote: '定位到原消息'
            }
        },
        ChatGroupSide: {
            members: '群成员',
            viewAllMembers: '查看全部{count}名成员',
            invite: '邀请',
            inviteTip: '邀请好友进群聊',
            remove: '移除',
            removeTip: '选择成员移出群聊',
            removeTitle: '选择成员进行移除',
            mute: '禁言',
            muteTip: '禁言',
            muteTitle: '选择成员进行禁言',
            unmute: '解除禁言',
            unmuteTip: '解除禁言',
            unmuteTitle: '选择成员进行解除禁言',
            notDisturb: '消息免打扰',
            pinChat: '置顶聊天',
            allMute: '全员禁言',
            allowInvite: '允许普通成员邀请好友',
            allowShareCard: '允许普通成员分享名片',
            autoTranslate: '自动翻译',
            groupName: '群聊名称',
            enterGroupName: '请输入群聊名称',
            clickSetGroupName: '点击设置群聊名称',
            remarkName: '备注名',
            clickSetRemark: '点击设置备注名',
            myNickname: '我在本群的昵称',
            enterNickname: '请输入昵称',
            clickSetNickname: '点击设置昵称',
            groupNotice: '群公告',
            clickSetNotice: '点击设置群公告',
            editNotice: '编辑群公告',
            enterNotice: '请输入群公告',
            clearChat: '清空聊天记录',
            quitGroup: '退出群聊',
            complaintTip: '被骚扰了？举报该群',
            dndEnabled: '已开启免打扰',
            dndDisabled: '已关闭免打扰',
            chatPinned: '已置顶聊天',
            chatUnpinned: '已取消置顶',
            operationFailed: '操作失败，请重试',
            membersRemoved: '您移除了{count}位成员',
            membersMuted: '您对{count}位成员进行了禁言',
            membersUnmuted: '您解除了{count}位成员的禁言',
            quitConfirm: '退出群聊后将不再接受群里的消息，确认退出吗？',
            confirmQuit: '确认退出?',
            clearConfirm: "确定要清空'{name}'的所有聊天记录吗？",
            clearChatRecords: '清空聊天记录',
            chatCleared: "您清空了'{name}'的聊天记录"
        },
        HeadImage: {
            online: '在线'
        },
        ResizableAside: {
            resize: {
                title: '调整大小'
            }
        },
        CaptchaImage: {
            title: '验证码',
            placeholder: '请输入验证码',
            required: '请输入验证码',
            error: '验证码错误'
        },
        NoDataTip: {
            default: '没有数据'
        },
        ChatItem: {
            tags: {
                group: '群聊',
                top: '置顶',
                official: '官方'
            },
            atText: {
                someone: '有人@我',
                all: '有人@所有人'
            },
            menu: {
                top: '置顶聊天',
                cancelTop: '取消置顶',
                viewInfo: '查看资料',
                newMessageAlert: '新消息通知',
                doNotDisturb: '免打扰',
                deleteChat: '删除聊天'
            }
        },
        RtcPrivateVideo: {
            waiting: '等待对方接听...',
            hangup: '挂断',
            error: {
                deviceNotSupport: '对方设备不支持通话',
                acceptedOnOtherDevice: '已在其他设备接听',
                rejectedOnOtherDevice: '已在其他设备拒绝',
                rejected: '对方已拒绝您的通话请求',
                notAnswered: '您未接听',
                otherNotAnswered: '对方未接听',
                otherCanceled: '对方取消了呼叫',
                otherHungUp: '对方已挂断'
            },
            success: {
                hangup: '您已挂断,通话结束',
                cancel: '已取消呼叫,通话结束'
            }
        },
        UserInfo: {
            tag: {
                deleted: '已删除',
                banned: '已封禁'
            },
            copyUserId: '复制用户ID',
            signature: {
                label: '个性签名',
                default: '这个人很懒，什么都没有留下'
            },
            button: {
                sendMessage: '发送消息',
                addFriend: '添加好友'
            },
            status: {
                waitingApprove: '等待审核'
            },
            copy: {
                success: '复制成功: {content}',
                fail: '复制失败'
            }
        },
        ChatPrivateSide: {
            dnd: '免打扰',
            top: '置顶',
            blacklist: '黑名单',
            remark: '备注',
            enterRemark: '请输入备注',
            clickSetRemark: '点击设置备注',
            cleanChat: '清空聊天',
            deleteFriend: '删除好友',
            complaint: '投诉',
            message: {
                dndEnabled: '已开启免打扰',
                dndDisabled: '已关闭免打扰',
                chatPinned: '已置顶聊天',
                chatUnpinned: '已取消置顶',
                operationFailed: '操作失败，请重试',
                addToBlacklist: "已将'{name}'加入黑名单",
                removeFromBlacklist: "已解除'{name}'的黑名单",
                chatCleared: "您清空了'{name}'的聊天记录",
                remarkSaved: '备注设置成功',
                remarkCleared: '备注已清除',
                friendDeleted: "已删除好友 '{name}'",
                deleteFailed: '删除失败，请重试',
                copySuccess: "内容'{content}'已复制到剪贴板",
                copyFailed: '复制失败，请手动复制'
            },
            confirm: {
                addToBlacklist: "您将不再收到对方的消息,确认将 '{name}'加入黑名单吗?",
                addToBlacklistTitle: '加入黑名单',
                clearChat: "确定要清空与'{name}'的所有聊天记录吗？",
                clearChatTitle: '清空聊天记录',
                deleteFriend: "确定要删除好友 '{name}' 吗？删除后将无法恢复。",
                deleteFriendTitle: '删除好友',
                confirmButton: '确定',
                cancelButton: '取消'
            }
        }
    },
    setting: {
        language: '语言设置',
        switchLanguage: '切换语言',
        currentLanguage: '当前语言'
    }
}
